import type { DocsDataState } from '@/models/docs-data/docsData';

export function isAlgoliaSearchEnabled(
  searchSettings: DocsDataState['searchSettings'],
): searchSettings is NonNullable<DocsDataState['searchSettings']> {
  // const isIpHostname = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(window.location.hostname);
  // if (isIpHostname || isPdv) return true;
  // isCustomDomain &&
  // 暂时无需一定要自定义域名，一样可以使用和 preview
  const isBuilding =
    searchSettings?.algoliaRebuildStatus === 'BUILDING' ||
    searchSettings?.algoliaRebuildStatus === 'PENDING';
  const result =
    searchSettings &&
    searchSettings?.type === 'ALGOLIA' &&
    searchSettings?.appId &&
    searchSettings?.indexName &&
    searchSettings?.searchApiKey &&
    // 索引场景失败的时候不使用 algolia search
    searchSettings?.algoliaRebuildStatus !== 'FAILED' &&
    (!isBuilding || !!searchSettings?.algoliaDocSearchRebuiltAt);

  return Boolean(result);
}

export function isLocalSearchEnabled(
  searchSettings: DocsDataState['searchSettings'],
  // options: {
  //   language?: string;
  // },
): searchSettings is NonNullable<DocsDataState['searchSettings']> {
  // const { language } = options;
  // if (!language || !language.includes('en')) {
  //   return false;
  // }
  const isBuilding =
    searchSettings?.localSearchRebuildStatus === 'BUILDING' ||
    searchSettings?.localSearchRebuildStatus === 'PENDING';

  const result =
    searchSettings &&
    searchSettings?.type === 'DEFAULT' &&
    searchSettings.localSearchRebuildStatus !== 'FAILED' &&
    (!isBuilding || !!searchSettings?.algoliaDocSearchRebuiltAt) &&
    searchSettings.localSearchIndexDataURL &&
    searchSettings.localSearchIndexSettingsURL;

  return Boolean(result);
}

export const localSearchFallbackResponse = {
  status: 200,
  content: '{"results":[]}',
  isTimedOut: false,
};
